<span class="badge campanha-status-badge"
    [class.campanha-status-nao-confirmada]="config?.isNaoConfirmada"
    [class.campanha-status-em-analise]="config?.isEmAnalise"
    [class.campanha-status-reprovada]="config?.isReprovada"
    [class.campanha-status-em-andamento]="config?.isEmAndamento"
    [class.campanha-status-em-revisao]="config?.isEmRevisao"
    [class.campanha-status-encerrada]="config?.isEncerrada"
    [style.fontSize]="fontSize">
    <i class="{{status | campanhaStatusIcon }}"></i>
    {{status | campanhaStatus }}
</span>